export default __webpack_public_path__ + "static/media/IMG2287.4b3e2fe0.jpg";